import React from 'react';
import {observer} from "mobx-react";
import {formatDate} from "core/common/utils/dateUtils";
import {lovLabel} from "core/form/formUtils";
import {abbreviate} from "core/common/utils/stringUtils";
import {PartyCreditEntry} from "accounting/accountingDomain";
import {Price} from "product/productDomain";
import {DEFAULT_CURRENCY_FORMAT, formatNumber} from "core/common/utils/numberUtils";
import {classNames} from "core/common/utils/domUtils";


export const PartyCreditEntryTable = observer(({creditEntries, style}: { creditEntries: PartyCreditEntry[], style?: any }) => {


  return (creditEntries && creditEntries.length) ? (
    <table className="zz-simple-table" style={style}>
      <thead>
      <tr>
        <th>Value Date</th>
        <th>Amount</th>
        <th>PaymentType</th>
        <th>Bank Transaction</th>
        <th>Credit Note</th>
        <th>Match Type</th>
      </tr>
      </thead>
      <tbody>
      {creditEntries.map((creditEntry, index) => {
        //let mdField = entity.getField(field.fieldName);
        let moneyClass = classNames({'color-green-500': creditEntry.amount > 0, 'color-red-500': creditEntry.amount < 0});
        return (
          <tr key={index}>
            <td className={moneyClass}>{formatDate(creditEntry.valueDate)}</td>
            <td className={moneyClass}>{creditEntry.getFullAmount()}</td>
            <td className={moneyClass}>{lovLabel(creditEntry.paymentType)}</td>
            <td className={moneyClass}>{abbreviate(lovLabel(creditEntry.bankTransaction), 60)}</td>
            <td className={moneyClass}>{lovLabel(creditEntry.creditNote)}</td>
            <td className={moneyClass}>{lovLabel(creditEntry.matchType)}</td>
          </tr>
        )
      })}
      </tbody>
    </table>
  ) : null;


});


export const PartyCreditSumTable = observer(({sums, style}: { sums: Price[], style?: any }) => {
  return (sums && sums.length) ? (
    <div style={{display: 'flex'}}>
      <div style={{marginRight: 10, marginTop: 10}}>Credit sums: </div>
      <table className="zz-simple-table" style={Object.assign({minWidth: 'unset'}, style)}>
        <tbody>
        {sums.map((price, index) => {
          //let mdField = entity.getField(field.fieldName);
          let moneyClass = classNames({'color-green-500': price.price > 0, 'color-red-500': price.price < 0});
          return (
            <tr key={index}>
              <td className={moneyClass} style={{borderTop: 'unset'}}>{formatNumber(price.price, DEFAULT_CURRENCY_FORMAT)}</td>
              <td className={moneyClass} style={{borderTop: 'unset'}}>{price.currency}</td>
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>
  ) : null;


});



// WEBPACK FOOTER //
// ./src/party/component/partyCreditEntry.tsx